import { useState, useEffect } from 'react';
import { api } from '../App';
import { DAILY_CARE_CATEGORIES, GENTLING_CATEGORIES } from '../constants/horseConstants';

/**
 * Hook to fetch and manage herd settings (Daily Care and Training categories)
 * Falls back to default constants if backend settings are not available
 */
export const useHerdSettings = () => {
  const [herdSettings, setHerdSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchHerdSettings();
  }, []);

  const fetchHerdSettings = async () => {
    try {
      setLoading(true);
      const response = await api.get('/herd-settings');
      setHerdSettings(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching herd settings:', err);
      setError(err);
      // Settings will fall back to defaults
    } finally {
      setLoading(false);
    }
  };

  // Get daily care categories - use backend settings or fall back to constants
  const dailyCareCategories = herdSettings?.daily_care_categories?.length > 0
    ? herdSettings.daily_care_categories
    : DAILY_CARE_CATEGORIES;

  // Get training categories - use backend settings or fall back to constants
  const trainingCategories = herdSettings?.training_categories?.length > 0
    ? herdSettings.training_categories
    : GENTLING_CATEGORIES;

  return {
    herdSettings,
    dailyCareCategories,
    trainingCategories,
    loading,
    error,
    refetch: fetchHerdSettings
  };
};

export default useHerdSettings;
